import { FormFieldOptionDetails, FormResponseValue } from "@tellescope/types-models";
import { responsesSatisfyConditions } from "./responses-satisfy-conditions";
import { NextFieldLogicOptions } from "./types";

export const resolveVisibleChoices = ({
  optionDetails,
  responses,
  logicOptions,
}: {
  optionDetails: FormFieldOptionDetails[];
  responses: FormResponseValue[];
  logicOptions?: NextFieldLogicOptions;
}): FormFieldOptionDetails[] =>
  optionDetails.filter((detail) => {
    if (!detail.showCondition || !Object.keys(detail.showCondition).length) return true;
    return responsesSatisfyConditions(responses, detail.showCondition, {
      ...logicOptions,
      activeResponses: logicOptions?.activeResponses ?? responses,
    });
  });
